/* eslint-disable global-require */

import { setPackageFromJson } from '../../app/package-designer/store/package.actions';
import { NAV_DATA_KEY } from '../../app/constants/app';
import { loginSuccess } from '../../app/account/store/account.actions';

xplenty.config([
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider',
  '$urlMatcherFactoryProvider',
  function ($stateProvider, $urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.strictMode(false);

    $stateProvider.state('app', {
      url: '/',
      template: require('../../views/layouts/app.html'),
      controller: 'app.controller',
      title: 'app.router.titles.app',
      data: {
        requireLogin: true,
      },
      resolve: {
        validationsLoaded: [
          'validationExportsService',
          function (validationExportsService) {
            return validationExportsService.loadValidations();
          },
        ],
      },
    });

    $stateProvider
      .state('404', {
        url: '/404',
        template: `<error404></error404>`,
        title: 'app.router.titles.404',
        data: {
          requireLogin: false,
        },
      })
      .state('401', {
        url: '/401',
        template: `<error401></error401>`,
        title: 'app.router.titles.401',
        data: {
          requireLogin: false,
        },
      })
      .state('welcome', {
        url: '/welcome',
        template: `<welcome></welcome>`,
        title: 'app.router.titles.app_welcome',
        data: {
          requireLogin: false,
        },
      })
      .state('welcome.start', {
        url: '/start',
        template: `<welcome></welcome>`,
        title: 'app.router.titles.app_welcome',
        data: {
          requireLogin: false,
        },
      });

    $stateProvider.state('app.launchpad', {
      url: 'launchpad',
      template: `<launchpad></launchpad>`,
      title: 'app.router.titles.app',
    });

    // PARTNERS
    $stateProvider.state('partners', {
      url: '/partners/{partner:heroku|awsmarketplace}/sso?token&nav-data',
      controller: [
        '$rootScope',
        'AuthService',
        'herokuBoomerangService',
        '$state',
        '$location',
        'ngrxStoreService',
        function ($rootScope, AuthService, herokuBoomerangService, $state, $location, ngrxStoreService) {
          const search = $location.search();

          AuthService.setToken(search.token);

          window.localStorage.setItem(NAV_DATA_KEY, search[NAV_DATA_KEY]);

          herokuBoomerangService.init();

          ngrxStoreService.dispatch(loginSuccess());

          $state.go('app.launchpad');
        },
      ],
      params: {
        token: {
          value: '',
          squash: true,
        },
        'nav-data': {
          value: '',
          squash: true,
        },
      },
    });
    // AUTH
    // ==============================================
    $stateProvider.state('app.auth', {
      url: 'auth',
      template: require('../../views/layouts/auth.html'),
      title: 'app.router.titles.app_auth',
      data: {
        requireLogin: false,
      },
    });
    $stateProvider.state('app.email_confirmation', {
      url: 'account/new_email_confirmation/:token',
      template: `<email-confirmation></email-confirmation>`,
    });
    // sign-in -------------------------------------
    $stateProvider.state('app.auth.signin', {
      url: '/login',
      template: `<sign-in></sign-in>`,
      title: 'app.router.titles.app_auth_signin',
      params: {
        return_url: {
          value: '',
          squash: true,
        },
      },
    });
    // sign-in -------------------------------------
    $stateProvider.state('app.auth.signin-support', {
      url: '/support/login',
      template: `<sign-in></sign-in>`,
      controller: 'auth.signin.controller',
      title: 'app.router.titles.app_auth_signin',
      params: {
        showForm: true,
        return_url: {
          value: '',
          squash: true,
        },
      },
    });
    // sign-up -------------------------------------
    $stateProvider.state('app.auth.signup', {
      url: '/signup',
      template: `<sign-up></sign-up>`,
      title: 'app.router.titles.app_auth_signup',
    });
    // sign-up -------------------------------------
    $stateProvider.state('app.auth.signupold', {
      url: '/signup/old',
      template: `<sign-up></sign-up>`,
      title: 'app.router.titles.app_auth_signup',
    });
    // sign-up free trial -------------------------------------
    $stateProvider.state('app.auth.signup-freetrial', {
      url: '/signup/freetrial',
      template: `<sign-up-free-trial></sign-up-free-trial>`,
      title: 'app.router.titles.app_auth_signup',
    });
    // confirmation -------------------------------------
    $stateProvider.state('app.auth.confirmation', {
      url: '/confirmation?token',
      template: `<confirmation></confirmation>`,
      title: 'app.router.titles.app_auth_confirmation',
      data: {
        requireLogin: false,
      },
      params: {
        token: {
          value: '',
          squash: true,
        },
      },
    });
    // confirmation -------------------------------------
    $stateProvider.state('app.auth.thankyou', {
      url: '/thank-you',
      template: `<thank-you></thank-you>`,
      title: 'app.router.titles.app_auth_thankyou',
    });
    // confirmation -------------------------------------
    $stateProvider.state('app.auth.thankyou.free-trial', {
      url: '/freetrial',
      template: `<thank-you></thank-you>`,
      title: 'app.router.titles.app_auth_thankyou',
    });
    // forgot -------------------------------------
    $stateProvider.state('app.auth.forgot', {
      url: '/forgot',
      template: `<forgot-password></forgot-password>`,
      title: 'app.router.titles.app_auth_forgot',
    });

    // reset  -------------------------------------
    $stateProvider.state('app.auth.reset', {
      url: '/password_reset?email&reset_password_token',
      template: '<reset-password></reset-password>',
      title: 'app.router.titles.app_auth_reset',
      params: {
        email: {
          value: '',
          squash: true,
        },
        reset_password_token: {
          value: '',
          squash: true,
        },
      },
    });
    // invitation  -------------------------------------
    $stateProvider.state('app.auth.invitation', {
      url: '/invitation?token',
      template: '<members-invitation></members-invitation>',
      title: 'app.router.titles.app_auth_invitation',
      params: {
        account_id: {
          value: '',
          squash: true,
        },
        token: {
          value: '',
          squash: true,
        },
      },
    });
    // invitation  -------------------------------------
    $stateProvider.state('app.invite_new_member', {
      url: ':account_id/settings/members/invitation/:token',
      controller: [
        '$state',
        '$stateParams',
        function ($state, $stateParams) {
          $state.go('app.auth.invitation', $stateParams);
        },
      ],
      data: {
        requireLogin: false,
      },
    }); // invitation  -------------------------------------
    $stateProvider.state('app.signup_confirmation', {
      url: 'signup/confirmation/:token',
      controller: [
        '$state',
        '$stateParams',
        function ($state, $stateParams) {
          $state.go('app.auth.confirmation', $stateParams);
        },
      ],
      data: {
        requireLogin: false,
      },
    });
    // // ACCOUNT
    // ==============================================
    $stateProvider.state('app.account', {
      url: ':account_id',
      template: require('../../views/layouts/account.html'),
      controller: 'account.controller',
      title: 'app.router.titles.app_account',
      data: {
        requireLogin: true,
        permissions: {
          only: 'viewProfile',
        },
      },
      resolve: {
        accountValidationsLoaded: [
          '$stateParams',
          'validationExportsService',
          function ($stateParams, validationExportsService) {
            return validationExportsService.loadValidations();
          },
        ],
      },
    });
    // CONNECTIONS -------------------------------------
    $stateProvider
      .state('app.account.connections', {
        url: '/connections',
        views: {
          main: {
            template: `<connections-list></connections-list>`,
          },
        },
        title: 'app.router.titles.app_account_connections',
        data: {
          permissions: {
            only: 'listConnections',
          },
        },
      })
      .state('app.account.connections.new', {
        url: '/new',
        title: 'app.router.titles.app_account_connections_new',
        data: {
          permissions: {
            only: 'createConnection',
          },
          action: 'new',
        },
      })
      .state('app.account.connections.type', {
        url: '/:type',
        abstract: true,
      })
      .state('app.account.connections.type.new', {
        url: '/new',
        title: 'app.router.titles.app_account_connections_type_new',
        data: {
          permissions: {
            only: 'createConnection',
          },
          action: 'new',
        },
      })
      .state('app.account.connections.type.item', {
        url: '/:id',
        title: 'app.router.titles.app_account_connections_type_item',
        data: {
          permissions: {
            only: 'viewConnection',
          },
        },
      })
      .state('app.account.connections.type.item.edit', {
        url: '/edit',
        title: 'app.router.titles.app_account_connections_type_edit',
        data: {
          permissions: {
            only: 'updateConnection',
          },
        },
      });
    // PACKAGES -------------------------------------
    $stateProvider
      .state('app.account.packages', {
        url: '/packages?query',
        views: {
          main: {
            template: `<packages-list></packages-list>`,
          },
        },
        title: 'app.router.titles.app_account_packages',
        data: {
          permissions: {
            only: 'listPackages',
          },
        },
      })
      .state('app.account.packages.new', {
        url: '/new',
        title: 'app.router.titles.app_account_packages_new',
        data: {
          permissions: {
            only: 'createPackage',
          },
          action: 'new',
        },
      })
      .state('app.account.packages.item', {
        url: '/:id',
        abstract: true,
        data: {
          permissions: {
            only: 'viewPackage',
          },
        },
        resolve: {
          item: [
            '$stateParams',
            'Package',
            'ngrxStoreService',
            function ($stateParams, Package, ngrxStoreService) {
              return Package.get(
                $stateParams.id,
                {
                  include: 'flow',
                },
                $stateParams.account_id,
              )
                .toPromise()
                .then(function (_package) {
                  // ngrxStoreService.dispatch(setPackageFromJson({ packageItem: _package }));
                  return _package;
                });
            },
          ],
        },
      })
      .state('app.account.packages.item.edit', {
        url: '/edit',
        views: {
          'main@app.account': {
            template: require('../../views/pages/packages/packages.item.html'),
            controller: 'packages.item.controller',
          },
        },
        data: {
          permissions: {
            only: 'updatePackage',
          },
        },
      })
      .state('app.account.packages.item.edit-new', {
        url: '/edit-new',
        views: {
          'main@app.account': {
            template: '<xp-designer></xp-designer>',
            // controller: 'packages.item.controller',
          },
        },
        data: {
          permissions: {
            only: 'updatePackage',
          },
        },
      })
      .state('app.account.packages.item.versions', {
        url: '/versions',
        data: {
          permissions: {
            only: 'versionControl',
          },
        },
      })
      .state('app.account.packages.item.versions.edit', {
        url: '/:version',
        views: {
          'main@app.account': {
            template: require('../../views/pages/packages/packages.item.html'),
            controller: 'packages.item.version.controller',
          },
        },
        params: {
          package: null,
        },
        data: {
          permissions: {
            only: 'versionControl',
          },
        },
      });

    // WORKSPACES -------------------------------
    $stateProvider
      .state('app.account.workspaces', {
        url: '/workspaces?query',
        views: {
          main: {
            template: '<workspaces-list></workspaces-list>',
          },
        },
        title: 'app.router.titles.app_account_workspaces',
        data: {
          permissions: {
            only: 'listJobs',
          },
        },
      })
      .state('app.account.workspaces.new', {
        url: '/new',
        title: 'app.router.titles.app_account_workspaces_new',
        data: {
          permissions: {
            only: 'createPackage',
          },
          action: 'new',
        },
      })
      .state('app.account.workspaces-item', {
        url: '/workspaces/:workspace_id',
        views: {
          main: {
            template: `<packages-list></packages-list>`,
          },
        },
        title: 'app.router.titles.app_account_packages',
        data: {
          permissions: {
            only: 'listJobs',
          },
        },
      })
      .state('app.account.workspaces-item.new-package', {
        url: '/new',
        title: 'app.router.titles.app_account_packages_new',
        data: {
          permissions: {
            only: 'createPackage',
          },
          action: 'new',
        },
      });

    // JOBS -------------------------------------
    $stateProvider
      .state('app.account.jobs', {
        url: '/jobs?query',
        views: {
          main: {
            template: `<jobs-list></jobs-list>`,
          },
        },
        title: 'app.router.titles.app_account_jobs',
        data: {
          permissions: {
            only: 'listJobs',
          },
        },
      })
      .state('app.account.jobs.new', {
        url: '/new',
        title: 'app.router.titles.app_account_jobs_new',
        data: {
          permissions: {
            only: 'createJob',
          },
          action: 'new',
        },
      })
      .state('app.account.jobs.item', {
        url: '/:id',
        title: 'app.router.titles.app_account_jobs_item',
        data: {
          permissions: {
            only: 'viewJob',
          },
        },
      })
      .state('app.account.jobs.item.outputs', {
        url: '/outputs',
        title: 'app.router.titles.app_account_jobs_item_outputs',
      })
      .state('app.account.jobs.item.errors', {
        url: '/errors',
        title: 'app.router.titles.app_account_jobs_item_errors',
      })
      .state('app.account.jobs.item.variables', {
        url: '/variables',
        title: 'app.router.titles.app_account_jobs_item_variables',
      })
      .state('app.account.jobs.item.tasks', {
        url: '/tasks',
        title: 'app.router.titles.app_account_jobs_item_tasks',
      })
      .state('app.account.jobs.item.children', {
        url: '/children/:child_id',
        title: 'app.router.titles.app_account_jobs_item',
      })
      .state('app.account.jobs.item.children.general', {
        url: '/general',
        title: 'app.router.titles.app_account_jobs_item_general',
      })
      .state('app.account.jobs.item.children.outputs', {
        url: '/outputs',
        title: 'app.router.titles.app_account_jobs_item_outputs',
      })
      .state('app.account.jobs.item.children.errors', {
        url: '/errors',
        title: 'app.router.titles.app_account_jobs_item_errors',
      })
      .state('app.account.jobs.item.children.variables', {
        url: '/variables',
        title: 'app.router.titles.app_account_jobs_item_variables',
      });

    // CLUSTERS -------------------------------------
    $stateProvider
      .state('app.account.clusters', {
        url: '/clusters?query',
        views: {
          main: {
            template: `<clusters-list></clusters-list>`,
          },
        },
        title: 'app.router.titles.app_account_clusters',
        data: {
          permissions: {
            only: 'listClusters',
          },
        },
      })
      .state('app.account.clusters.new', {
        url: '/new',
        title: 'app.router.titles.app_account_clusters_new',
        data: {
          permissions: {
            only: 'createCluster',
          },
          action: 'new',
        },
      })
      .state('app.account.clusters.item', {
        url: '/:id',
        title: 'app.router.titles.app_account_clusters_item',
        abstract: true,
        data: {
          permissions: {
            only: 'viewCluster',
          },
        },
      })
      .state('app.account.clusters.item.edit', {
        url: '/edit',
        title: 'app.router.titles.app_account_clusters_item_edit',
        data: {
          permissions: {
            only: 'updateCluster',
          },
        },
      });

    // SCHEDULES -------------------------------------
    $stateProvider
      .state('app.account.schedules', {
        url: '/schedules?query',
        views: {
          main: {
            template: `<schedules-list></schedules-list>`,
          },
        },
        title: 'app.router.titles.app_account_schedules',
        data: {
          permissions: {
            only: 'listSchedules',
          },
        },
      })
      .state('app.account.schedules.new', {
        url: '/new',
        title: 'app.router.titles.app_account_schedules_new',
        data: {
          permissions: {
            only: 'createSchedule',
          },
          action: 'new',
        },
      })
      .state('app.account.schedules.item', {
        url: '/:id',
        title: 'app.router.titles.app_account_schedules_item',
        data: {
          permissions: {
            only: 'viewSchedule',
          },
        },
      })
      .state('app.account.schedules.item.edit', {
        url: '/edit',
        title: 'app.router.titles.app_account_schedules_item_edit',
        data: {
          permissions: {
            only: 'updateSchedule',
          },
        },
      });

    $stateProvider.state('app.account.console', {
      url: '/help/console',
      views: {
        main: {
          template: `<xplenty-console></xplenty-console>`,
        },
      },
      title: 'app.router.titles.app_account_console',
    });

    // Account SETTINGS -------------------------------------
    $stateProvider
      .state('app.account.settings', {
        url: '/settings',
        views: {
          main: {
            template: `
            <div class="settings">
              <div ui-view autoscroll="true"></div>
            </div>
            `,
            // eslint-disable-next-line object-shorthand
            controller: function () {
              window.email_required = true;
              window.email_changed = true;
            },
          },
        },
        title: 'app.router.titles.app_account_settings',
      })
      .state('app.account.settings.account', {
        url: '/account',
        template: '<ui-view/>',
        title: 'app.router.titles.app_account_settings_account',
        abstract: true,
      })
      // account profile -------------------------------------
      .state('app.account.settings.account.info', {
        url: '/profile',
        template: `<account-settings-info></account-settings-info>`,
        title: 'app.router.titles.app_account_settings_account_info',
        data: {
          permissions: {
            only: 'viewProfile',
          },
        },
      })
      // account billing -------------------------------------
      .state('app.account.settings.account.plans', {
        url: '/billing',
        template: `<account-settings-billing></account-settings-billing>`,
        title: 'app.router.titles.app_account_settings_account_plans',
        data: {
          permissions: {
            only: 'viewBillingInfo',
          },
        },
      })
      // account members -------------------------------------
      .state('app.account.settings.account.members', {
        url: '/members',
        template: `<members-list></members-list>`,
        title: 'app.router.titles.app_account_settings_account_members',
        data: {
          permissions: {
            only: 'listMembers',
          },
        },
      })
      .state('app.account.settings.account.members.new', {
        url: '/new',
        title: 'app.router.titles.app_account_settings_account_members_new',
        data: {
          permissions: {
            only: 'inviteMember',
          },
          action: 'new',
        },
      })
      // account member info -------------------------------------
      .state('app.account.settings.account.member', {
        url: '/members/:id',
        template: `<members-item></members-item>`,
        title: 'app.router.titles.app_account_settings_account_members',
        data: {
          permissions: {
            only: 'viewMember',
          },
        },
      })
      // account service hooks -------------------------------------
      .state('app.account.settings.account.hooks', {
        url: '/hooks',
        template: `<hooks-list></hooks-list>`,
        title: 'app.router.titles.app_account_settings_account_hooks',
        data: {
          permissions: {
            only: 'listHooks',
          },
        },
      })
      .state('app.account.settings.account.hooks.new', {
        url: '/new',
        title: 'app.router.titles.app_account_settings_account_hooks_new',
        data: {
          permissions: {
            only: 'createHook',
          },
          action: 'new',
        },
      })
      .state('app.account.settings.account.hooks.type', {
        url: '/:type',
        title: 'app.router.titles.app_account_settings_account_hooks_type',
      })
      .state('app.account.settings.account.hooks.type.new', {
        url: '/new',
        title: 'app.router.titles.app_account_settings_account_hooks_type_new',
        data: {
          permissions: {
            only: 'createHook',
          },
          action: 'new',
        },
      })
      .state('app.account.settings.account.hooks.type.item', {
        url: '/:id',
        abstract: true,
      })
      .state('app.account.settings.account.hooks.type.item.edit', {
        url: '/edit',
        title: 'app.router.titles.app_account_settings_account_hooks_type_edit',
        data: {
          permissions: {
            only: 'updateHook',
          },
        },
      })
      // account usage -------------------------------------
      .state('app.account.settings.account.usage', {
        url: '/usage',
        template: `<account-settings-usage></account-settings-usage>`,
        title: 'app.router.titles.app_account_settings_account_usage',
        data: {
          permissions: {
            only: 'viewUsage',
          },
        },
      });
    // MY SETTINGS
    // ==============================================
    $stateProvider
      .state('app.account.settings.my', {
        url: '/my',
        abstract: true,
        template: '<ui-view/>',
        title: 'app.router.titles.app_account_settings_my',
      })
      // profile -------------------------------------
      .state('app.account.settings.my.info', {
        url: '/profile',
        template: `<settings-profile></settings-profile>`,
        title: 'app.router.titles.app_account_settings_my_info',
      })
      // password -------------------------------------
      .state('app.account.settings.my.password', {
        url: '/password',
        template: `<settings-password></settings-password>`,
        title: 'app.router.titles.app_account_settings_my_password',
      })
      // mfa -------------------------------------
      .state('app.account.settings.my.mfa', {
        url: '/mfa',
        template: `<settings-mfa></settings-mfa>`,
        title: 'app.router.titles.app_account_settings_my_mfa',
      })
      // notifications -------------------------------------
      .state('app.account.settings.my.notifications', {
        url: '/notifications',
        template: `<settings-notifications></settings-notifications>`,
        title: 'app.router.titles.app_account_settings_my_notifications',
      })
      // ssh keys -------------------------------------
      .state('app.account.settings.my.keys', {
        url: '/keys',
        template: `<keys-list></keys-list>`,
        title: 'app.router.titles.app_account_settings_my_keys',
      })
      // ssh keys add -------------------------------------
      .state('app.account.settings.my.keys.new', {
        url: '/new',
        title: 'app.router.titles.app_account_settings_my_keys_new',
        data: {
          action: 'new',
        },
      })
      // accounts list --------------------------------
      .state('app.account.settings.my.accounts', {
        url: '/accounts',
        template: `<accounts-list></accounts-list>`,
        title: 'app.router.titles.app_account_settings_my_accounts_list',
      })
      // accounts new ---------------------------------
      .state('app.account.settings.my.accounts.new', {
        url: '/new',
        title: 'app.router.titles.app_account_settings_my_accounts_new',
        data: {
          action: 'new',
        },
      });
    // DEVELOPER SETTINGS
    // ==============================================
    $stateProvider
      .state('app.account.settings.developer', {
        url: '/developer',
        template: '<ui-view/>',
        abstract: true,
      })
      // api key ---------------------------------
      .state('app.account.settings.developer.tokens', {
        url: '/tokens',
        template: `<settings-tokens></settings-tokens>`,
        title: 'app.router.titles.app_account_settings_developer_tokens',
      });

    $urlRouterProvider.otherwise(function ($injector) {
      const $state = $injector.get('$state');
      $state.go('404', null, { location: false });
    });

    $locationProvider.html5Mode(true);
  },
]);
